import { call, put, takeLatest } from "redux-saga/effects";
import { addAttachmentEnquiry, getAttachmentEnquiry } from "../../utils/AttachmentEnquiry/AttachmentEnquiry";
import {
    ADD_ATTACHMENT_ENQUIRY,
    GET_ATTACHMENT_ENQUIRY,
    getAttachmentEnquiryFailure,
    getAttachmentEnquirySuccess,
} from "../actions/attachmentEnquiryAction";
import {
    addAttachmentEnquirySuccess,
    addAttachmentEnquiryFailure,
} from "../actions/attachmentEnquiryAction";

function* handleAddAttachmentEnquiry(action: any): Generator<any, void, any> {
    try {
        const response = yield call(addAttachmentEnquiry, action.payload);

        if (response?.data?.status === 200) {
            yield put(addAttachmentEnquirySuccess(response.data));
        } else {
            yield put(addAttachmentEnquiryFailure(response?.data?.message || "Failed to submit enquiry"));
        }
    } catch (error: any) {
        yield put(
            addAttachmentEnquiryFailure(
                error?.response?.data?.message || error?.message || "Something went wrong"
            )
        );
    }
}

function* handleGetAttachmentEnquiry(action: any): Generator<any, void, any> {
    try {
        const response = yield call(
            getAttachmentEnquiry,
            action.payload.cityid,
            action.payload.fromdate,
            action.payload.todate,
            action.payload.type,
            action.payload.status
        );

        if (response?.data?.status === 200) {
            yield put(getAttachmentEnquirySuccess(response.data.data));
        } else {
            yield put(getAttachmentEnquiryFailure(response?.data?.message || "Data not Found"));
        }
    } catch (error: any) {
        yield put(
            getAttachmentEnquiryFailure(
                error?.response?.data?.message || error?.message || "Something went wrong"
            )
        );
    }
}

export function* attachmentEnquirySaga() {
    yield takeLatest(ADD_ATTACHMENT_ENQUIRY, handleAddAttachmentEnquiry);
    yield takeLatest(GET_ATTACHMENT_ENQUIRY, handleGetAttachmentEnquiry);
}